import React, { memo } from 'react';
import styles from './dialogTitle.module.scss';

const DialogTitle = ({ children }) =>
    <div className={styles.dialogTitle}>
        {children}
    </div>

export default memo(DialogTitle);